import { useSyncExternalStore } from 'react';
import { hasSessionHint } from './session-hint';

const subscribe = () => () => undefined;
const serverHint = () => false;

export const useSessionHint = (): boolean =>
  useSyncExternalStore(subscribe, hasSessionHint, serverHint);
